import { useMemo } from 'react';
import { useConv0002Variant } from '../../../utils/hooks/useConv0002Variant';
import { useAppPersonalizationInstallStats } from '../../../utils/hooks/useAppPersonalizationInstallStats';
import { AppPersonalizationVariant1 } from './AppPersonalizationVariant1';
import { AppPersonalizationVariant2 } from './AppPersonalizationVariant2';
import { jsx as _jsx } from "react/jsx-runtime";
export const AppPersonalizationSection = ({
  offeringId
}) => {
  const conv0002Variant = useConv0002Variant();
  const appPersonalizationInstallStats = useAppPersonalizationInstallStats(offeringId);
  const hasAppPersonalizationStats = appPersonalizationInstallStats.country || appPersonalizationInstallStats.industry || appPersonalizationInstallStats.plan;
  const renderedVariant = useMemo(() => {
    switch (conv0002Variant) {
      case 'variant1':
        return /*#__PURE__*/_jsx(AppPersonalizationVariant1, {
          appPersonalizationInstallStats: appPersonalizationInstallStats
        });
      case 'variant2':
        return /*#__PURE__*/_jsx(AppPersonalizationVariant2, {});
      default:
        return null;
    }
  }, [conv0002Variant, appPersonalizationInstallStats]);

  // wait until we have variant data to render the container - this is mostly for testing purposes
  return conv0002Variant !== 'control' && hasAppPersonalizationStats && /*#__PURE__*/_jsx("div", {
    "data-test-id": "app-personalization-section",
    children: renderedVariant
  });
};